<template>
  <div class="OrderView">
      <!-- <Order style="float:left"/> -->


  <div style="width: 60%;float: left;">
    <v-data-table :headers="headers" :items="desserts" sort-by="name" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Products</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <!-- <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title> -->

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.title" label="Title"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.price" label="Price"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" hidden>
                      <v-text-field v-model="editedItem.wholesale_price" label="Wholesale Price"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.quantity" label="Quantity"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
                   <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn color="blue darken-1" text @click="save">Save</v-btn> -->
            </v-card-actions>
          </v-card>
          </v-dialog>
          <v-dialog v-model="dialogOrder" max-width="500px">
          <v-card>
            <v-card-title class="headline">
            <v-text-field value="John Doe" v-model="editedItem.name" label="Solo" solo readonly></v-text-field>
            <v-text-field value="John Doe" v-model="editedItem.name" label="Solo" solo readonly></v-text-field>
            <v-text-field v-model="editedItem.quantity" label="Quantity"></v-text-field>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeOrder">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="orderItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        </v-toolbar>
      </template>
        <template v-slot:[`item.actions`]="{ item }">
        <v-icon small @click="orderItem(item)">mdi-dialpad</v-icon>
      </template>
    </v-data-table>
  </div>

      <!--  -->
    <v-card  elevation="1" outlined style="float:right; width:39%;height: auto;">
      <center>
        <h1>Panier</h1>
        <v-data-table :headers="headerPanier" :items="panier" sort-by="name" class="">
          <template v-slot:top>
              <!-- dialog update panier -->
              <v-dialog v-model="dialogPanier" max-width="256px">
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="8" md="6">
                          <v-text-field v-model="editedItem.quantity" label="Name"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closePanier">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="editPanier">Save</v-btn>
                  </v-card-actions>
                </v-card>
        </v-dialog>
        <!-- fin dialog update panier -->
        <!-- dialog delete panier-->
          <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- fin dialog delete panier-->
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
        <br>
        <v-btn  elevation="7" large color="teal" class="mr-4" >Valider</v-btn>
        <br><br>
      </center>
        
    </v-card>
  </div>
</template>

<script>
import axios from 'axios';
  export default {
    name: 'OrderView',
    data(){
    return {
      dialog: false,
      dialogOrder: false,
      headers: [
        {text: 'name', value: 'name',},
        { text: 'title', value: 'title' },
        { text: 'price', value: 'price' },
        // { text: 'whole sale price', value: 'whole sale price' },
        { text: 'quantity', value: 'quantity' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headerPanier:[
        {text: 'name', value: 'name',},
        { text: 'quantity', value: 'quantity' },
        { text: 'price', value: 'price' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      panier:[],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: name,
        title: '',
        price: 0,
        wholesaleprice: 0,
        quantity: 0,
      },
      editedIndexPanier: -1,
      editedItemPanier: {
        name: name,
        title: '',
        price: 0,
        wholesaleprice: 0,
        quantity: 0,
      },
      // defaultItem: {
      //   name: '',
      //   title: '',
      //   price: 0,
      //   wholesaleprice: 0,
      //   quantity: 0,
      // },
    }
    },

    computed: {
      // formTitle () {
      //   return this.editedIndex === -1 ? 'New Product' : 'Edit Product'
      // },
    },

    watch: {
      dialog (val) {
        val || this.closePanier()
      },
      dialogOrder (val) {
        val || this.closeOrder()
      },
    },

    created () {
      if(!localStorage.getItem('user-token')){
        window.location.href = '../App';
      }
      this.initialize()
    },

    methods: {
      initialize () {
        //hadi matatexecutach !
        axios.get('http://localhost:8000/api/products',{
          headers:{
            'Authorization': 'Bearer '+localStorage.getItem('user-token')
          }
        })
        .then(response => {
          console.log(response.data)
          this.desserts = response.data
        })
      },
      editItem (item) {
        this.editedIndex = this.panier.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogPanier = true
      },
      deleteItem (item) {
        this.editedIndex = this.panier.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      orderItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogOrder = true
      },

      orderItemConfirm () {
        // axios.delete('http://localhost:8000/api/products/'+this.editedItem.id).then(response=>{
        //     console.log(response)
        // })
        this.panier.push(this.editedItem)
        this.closeOrder()
      },

      closePanier () {
        this.dialogPanier = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      deleteItemConfirm () {
        this.panier.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      closeOrder () {
        this.dialogOrder = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      editPanier(){
        Object.assign(this.panier[this.editedIndex], this.editedItem)
        this.closePanier()
      },

      save () {
        if (this.editedIndex > -1) {
         axios.put('http://localhost:8000/api/products/'+this.editedItem.id,this.editedItem).then(response=>{
           console.log(response)
         })  
        } else {
         axios.post('http://localhost:8000/api/products',this.editedItem).then(response=>{
           console.log(response)
         }) 
        }
        this.closeOrder()
        this.closePanier()
      },
    },
  }
</script>